import { useState } from "react";
import { Dialog, IconButton } from "@educaplay/core";
import { Search } from "@educaplay/core/Icons/Search";

import classes from "./imageContent.module.scss";

export default function ImageContent(props) {
  const { data, styles } = props;
  const [open, setOpen] = useState(false);

  const clickImage = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={(e) => {
          e.stopPropagation();
          setOpen(false);
        }}
        variant="lightbox"
      >
        <img src={data.src} alt="" />
      </Dialog>
      <div style={{ styles }} className={classes.imageContainer}>
        <div className={classes.container}>
          <img className={classes.image} src={data.src} alt=" " />
          <IconButton
            icon={<Search />}
            onClick={clickImage}
            className={classes.zoom}
          />
        </div>
      </div>
    </>
  );
}
